import './TermsCondition.css';

export default function TermCondition() {
    return (
        <>
        <section id="terms-conditions-section">
                <div className="terms-conditions-container">
                    <div className="terms-content">
                        {/* Section 1: Acceptance of Terms */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">1. Acceptance of Terms</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>By enrolling you confirm that you have read, understood, and agreed to all terms of HSM.</li>
                                    <li>These terms apply to all students of all courses (offline, online, Dual Program, All-in-One).</li>
                                    <li>HSM may update policies; updated terms automatically apply to ongoing students.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 2: Enrollment & Registration */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">2. Enrollment & Registration</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Admission is confirmed only after full fee payment or approved instalment plan.</li>
                                    <li>Students must submit correct personal details, age, and emergency contact.</li>
                                    <li>Admission is non-transferable to another person, unless permitted by HSM.</li>
                                    <li>For minors, a parent/guardian must sign the admission form.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 3: Course Duration & Flexibility */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">3. Course Duration & Flexibility</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Every course has a 30-day extra grace period for completion (e.g. 1-month course must be completed within 60 days).</li>
                                    <li>Grace period can be used only once per course.</li>
                                    <li>Extension beyond the grace period may require additional payment.</li>
                                    <li>The student is responsible for scheduling and completing classes within the allowed period.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 4: Attendance & Punctuality */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">4. Attendance & Punctuality</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Students must attend classes on time; lateness over 20 minutes may count as a missed class.</li>
                                    <li>Joining late reduces total class time and will not be extended.</li>
                                    <li>Classes cancelled by the academy will be rescheduled at no cost.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 5: Fees & Payment */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">5. Fees & Payment</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>All fees are to be paid in advance before the course starts.</li>
                                    <li>Fees are non-refundable except when a course is cancelled by HSM.</li>
                                    <li>Fees cannot be transferred to another student or carried forward to a future batch without written approval.</li>
                                    <li>Upgrading to a higher-priced course requires paying the difference; downgrading results in no refund.</li>
                                    <li>Any bank or platform charges are to be borne by the student.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 6: Refund & Cancellation */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">6. Refund & Cancellation</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Fees are non-refundable once the enrollment is complete.</li>
                                    <li>In medical emergencies or relocation cases, HSM may offer credit for future courses at its discretion.</li>
                                    <li>No refund/credit for missed classes due to poor internet, personal trips, or unapproved leaves.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 7: Teacher Allocation & Subject Change */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">7. Teacher Allocation & Subject Change</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Teacher assignment is at HSM's discretion.</li>
                                    <li>A student may request a teacher change if the teaching style does not suit them (subject to availability).</li>
                                    <li>Subject change allowed only within first 25 % of course duration, or with medical reasons/career-goal reasons approved by HSM.</li>
                                    <li>Any subject shift depends on availability, batch capacity, and teacher approval.</li>
                                    <li>Fee difference must be paid for higher-priced subjects; no refund for lower-priced subjects.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 8: Class Format */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">8. Class Format</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Classes may be 1-to-1 or group depending on program selected.</li>
                                    <li>Flexible timings are offered but fixed once booked; rescheduling requires 24-hour notice.</li>
                                    <li>Dual Program/All-in-One schedules are created by HSM; changes require prior approval.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 9: Rescheduling / Make-Up Classes */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">9. Rescheduling / Make-Up Classes</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Students may request reschedule at least 24 hours in advance (maximum 2 reschedules per month).</li>
                                    <li>Last-minute cancellations (less than 1 hours) count as a completed class.</li>
                                    <li>Make-up classes depend on teacher availability.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 10: Technical Requirements */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">10. Technical Requirements (Online Students only)</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Students must ensure a reliable internet connection, device, and functioning mic/camera.</li>
                                    <li>HSM is not responsible for classes missed due to student-side technical issues.</li>
                                    <li>If you face a technical error during class, immediately contact the support number; HSM will help resolve or reschedule if feasible.</li>
                                    <li>Students should log in 5 minutes early to check their setup.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 11: Study Material */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">11. Study Material</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>PDFs, audio files, and recordings provided are for personal learning only.</li>
                                    <li>Sharing, reproducing, or publishing study material without written permission is strictly prohibited.</li>
                                    <li>Any recordings made by students require HSM consent. Contact on your HSM administrator number for permission.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 12: Certification */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">12. Certification</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Certificates are awarded after full completion of the course, assignments, and minimum attendance.</li>
                                    <li>For graded/trinity exams, separate exam fees apply and are paid directly or through HSM, by the student.</li>
                                    <li>HSM reserves the right to withhold certificates in case of unpaid dues or violation of policies.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 13: Performance Opportunities */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">13. Performance Opportunities</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>HSM may provide internal showcases, live sessions, or event slots.</li>
                                    <li>Selection is based on skill, attendance, and readiness assessed by HSM.</li>
                                    <li>HSM does not guarantee paid gigs or media exposure.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 14: Career Support */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">14. Career Support</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>HSM offers general guidance on auditions, competitions, and artist branding.</li>
                                    <li>This is advisory and does not guarantee placements, sponsorships, or record deals.</li>
                                    <li>Additional mentorship packages may be offered separately.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 15: Use of Contact Information & Privacy */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">15. Use of Contact Information & Privacy</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Students and parents must not request or share personal contact information of teachers.</li>
                                    <li>All communication must happen through official HSM numbers, emails, or the student portal.</li>
                                    <li>Breach of this rule may result in termination without refund.</li>
                                    <li>All student data is kept confidential and used only for administrative purposes.</li>
                                    <li>Online classes may be recorded for quality and training purposes.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 16: Code of Conduct */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">16. Code of Conduct</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Students must behave respectfully with teachers, staff, and other students.</li>
                                    <li>Harassment, inappropriate language, or disruptive behaviour leads to termination without refund.</li>
                                    <li>Teachers reserve the right to end a class early if behaviour is inappropriate.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 17: Health & Safety */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">17. Health & Safety</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Students must disclose any vocal, physical, or medical conditions that could affect training.</li>
                                    <li>HSM is not liable for injuries or health issues resulting from practice.</li>
                                    <li>Students should warm up and practise safely as instructed.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 18: Intellectual Property */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">18. Intellectual Property</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>All logos, content, videos, and curriculum are property of HSM.</li>
                                    <li>Unauthorised distribution, sale, or use for commercial teaching is prohibited.</li>
                                    <li>HSM may use photos/videos of student performances, classes recordings for promotional purposes without consent.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 19: Dual Program & All-in-One Specific Rules */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">19. Dual Program & All-in-One Specific Rules</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>Students cannot choose Music Production, Dual Program, or All-in-One as one of the subjects inside these programs.</li>
                                    <li>Schedule is fixed by HSM to balance subjects; limited rescheduling.</li>
                                    <li>Completion requires meeting attendance for all included subjects.</li>
                                    <li>If a student drops one subject mid-way, fees are not refunded for that subject.</li>
                                </ul>
                            </div>
                        </div>

                        {/* Section 20: Amendments & Governing Law */}
                        <div className="terms-section">
                            <div className="terms-section-header">
                                <h3 className="terms-section-title">20. Amendments & Governing Law</h3>
                            </div>
                            <div className="terms-section-content">
                                <ul className="terms-list">
                                    <li>HSM reserves the right to modify any policy without prior notice.</li>
                                    <li>Updated terms apply immediately to all ongoing students.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}